export * from '../admin-common/api'
import * as commonApi from'../admin-common/api'
import{removeBranch}from'../admin-common/removal'

// Site removal in an extended Admin surface is dependency-aware. The backend
// keeps the final site record as an archive for audit/history.
export const archiveSite=(siteId,rootId,onStep)=>removeBranch(commonApi,siteId,rootId,onStep)
